import React from "react";
import algoliasearch from "algoliasearch";
import { InstantSearch } from "react-instantsearch-hooks-web";
import { useSiteContext } from "../../../context/site/useSiteContext";

export const searchClient = algoliasearch(
  process.env.GATSBY_CARLSBERG_HEADLESS_ALGOLIA_APP_ID || "",
  process.env.GATSBY_CARLSBERG_HEADLESS_ALGOLIA_API_KEY || ""
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AlgoliaWrapper: React.FC<any> = ({ children }) => {
  const { currentCulture } = useSiteContext();
  return (
    <InstantSearch
      routing
      searchClient={searchClient}
      indexName={
        currentCulture === "en-us"
          ? "bottle_collection_sort_brand_a-z"
          : "bottle_collection_dk_sort_brand_a-z"
      }
    >
      {children}
    </InstantSearch>
  );
};
